import { blobToDataUrl } from '$lib/utilities/blobToDataUrl';

export const updatePdfUrl = async (file, documentValues) => {
	const { PDFDocument, rgb, StandardFonts } = await import('pdf-lib');
	const res = await fetch(file.templateUrl);
	const buffer = await res.arrayBuffer();
	const pdfDoc = await PDFDocument.load(buffer);
	const courier = await pdfDoc.embedFont(StandardFonts.Courier);
	const pages = pdfDoc.getPages();

	console.log({ documentValues });

	if (Object.keys(documentValues || {}).length > 0) {
		for (const field of file.tags.split('-|-').map((field) => ({
			label: field,
			locations: file.fieldLocations[field]
		}))) {
			const value = documentValues[field.label] || '';
			for (const { page, X, Y, textHeight, textWidth } of field.locations) {
				const currentPage = pages[page - 1]; // pdf-lib uses 0-based index
				const { width, height } = currentPage.getSize();
				currentPage.drawRectangle({
					x: X,
					y: Y,
					width: textWidth,
					height: textHeight,
					color: rgb(1, 1, 1)
				});
				const maxWidth = width - file.leftMargin * 2 - X;
				// console.log({ value, lm: file.leftMargin, X, width, maxWidth });
				currentPage.drawText(value, {
					x: X,
					y: Y + 3,
					size: 12,
					font: courier,
					maxWidth,
					lineHeight: 12
				});
			}
		}
	} else {
		//no values so leave all the tags in the document
	}
	const newBuffer = await pdfDoc.save();
	const blob = new Blob([newBuffer], { type: 'application/pdf' });
	const hashBuf = await crypto.subtle.digest('SHA-256', newBuffer);
	const hashArr = Array.from(new Uint8Array(hashBuf));
	const hash = hashArr.map((b) => b.toString(16).padStart(2, '0')).join('');
	// file.hash = hash;
	const dataUrl = await blobToDataUrl(blob);
	// 	pdfUrl = dataUrl;
	// file.dataUrl = dataUrl;

	return { hash, dataUrl };

};
